<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <div>
      <span style="margin-left: 20px">累积用户: {{analyse.user}}</span> 人
      <span style="margin-left: 20px">累计发奖: {{analyse.sum}}</span> 美元
      <span style="margin-left: 20px">累计抽奖: {{analyse.count}}</span> 次
    </div>

    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import Url from '@/views/crs36/util/url'
  import Qs from 'qs'
  import download from "@/utils/download";
  let statusList = {1:"发放中",2:"发放成功",3:"发放失败"}
  let activeList = {1:"激活",2:"未激活"}
  let prizeList = {}
  export default {
    name: 'user',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('crs36.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
          this.analyse = {};
          if (data.luckyDrawId){
            this.dataChanage(Url.luckyDraw.record.winningThePrizeSum,data,res => {
              if (res.code == 0){
                this.analyse = res.result;
              }
            })
          }
        }else if(window.$t('crs36.bt.export') == clickName ){
          const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:false});
          download.exportExcel(Url.luckyDraw.record.export,param,"抽奖记录");
        }
      },
      bthClick (clickName, row) {
        this.dataChanage(Url.luckyDraw.record.handAddBonus,{id:row.id},res => {
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
          this.$refs.childTable.defaultGetData(this.queryData);
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
        })
      },
    },
    created() {
      if (this.$route.query.luckyDrawId){
        this.dataChanage(Url.luckyDraw.record.prizeList,{luckyDrawId:this.$route.query.luckyDrawId},res => {
          if (res.code == 0){
            for (let i in res.result) {
              prizeList[res.result[i].name] = res.result[i].name;
            }
            this.formData.cols = [
              { title: "活动ID", field: 'luckyDrawId',data:this.$route.query.luckyDrawId},
              { title: "用户账号", field: 'account'},
              {title: "开户时间",field: 'openTime',type: 6,format: 'yyyy-MM-dd HH:mm:ss',startEndParam: ['startOpenTime', 'endOpenTime']},
              {title: "激活时间",field: 'activeTime',type: 6,format: 'yyyy-MM-dd HH:mm:ss',startEndParam: ['startActivationTime', 'endActivationTime']},
              {title: "领奖时间",field: 'time',type: 6,format: 'yyyy-MM-dd HH:mm:ss',startEndParam: ['startTime', 'endTime']},
              { title: "奖项名称", field: 'name',type: 2,optionList: prizeList},
              { title: "发放状态", field: 'status',type:2,optionList:statusList},
              {click: window.$t('crs36.bt.search')},
              {click: window.$t('crs36.bt.export')},
            ]
          }
        })

      }

    },
    data () {
      return {
        analyse: {},
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: "活动ID", field: 'luckyDrawId',data:this.$route.query.luckyDrawId},
            { title: "用户账号", field: 'account'},
            {title: "开户时间",field: 'openTime',type: 6,format: 'yyyy-MM-dd HH:mm:ss',startEndParam: ['startOpenTime', 'endOpenTime']},
            {title: "激活时间",field: 'activeTime',type: 6,format: 'yyyy-MM-dd HH:mm:ss',startEndParam: ['startActivationTime', 'endActivationTime']},
            {title: "领奖时间",field: 'time',type: 6,format: 'yyyy-MM-dd HH:mm:ss',startEndParam: ['startTime', 'endTime']},
            { title: "奖项名称", field: 'name'},
            { title: "发放状态", field: 'status',type:2,optionList:statusList},
            {click: window.$t('crs36.bt.search'),auth:"crs36.lucky.record.query"},
            {click: window.$t('crs36.bt.export'),auth:"crs36.lucky.record.export"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.luckyDraw.record.query, //请求路径和参数
          sequence: true,
          cols: [
              { title: "活动ID", field: 'luckyDrawId'},
              { title: "用户账号", field: 'account'},
              { title: "用户名称", field: 'accountName'},
              { title: "真实开户时间", field: 'openAccountTime'},
              { title: "激活状态", field: 'activationStatus',render:(data,full)=>{
                  return activeList[data];
                }},
              { title: "激活时间", field: 'activationTime'},
              { title: "奖项名称", field: 'name'},
              { title: "奖品(美元)", field: 'bonus'},
              { title: "发放状态", field: 'status',render:(data,full)=>{
                  return statusList[data];
                }},
            { title: "领奖时间", field: 'createDate'},
            {field:"手动发奖",title:window.$t('txmis.bt.operation'),size:"mini",click:"handAddBonus",type:"primary",icon:"el-icon-edit",hidden:(full,data)=>{
              return full.status == 2;
              },auth:"crs36.lucky.record.addBonus"},
          ],
        },
      }
    }
  }
</script>
